// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";
import infiniteScroll from "./infiniteScroll";

// Font Awesome SVG (tree-shakeable - only bundles icons you import)
import { library, dom } from "@fortawesome/fontawesome-svg-core";
import {
    faFacebookF,
    faInstagram,
    faXTwitter,
    faTiktok,
    faThreads,
} from "@fortawesome/free-brands-svg-icons";
import { faHeart, faRss, faBars } from "@fortawesome/free-solid-svg-icons";

library.add(
    faFacebookF,
    faInstagram,
    faXTwitter,
    faTiktok,
    faThreads,
    faHeart,
    faRss,
    faBars,
);
dom.watch(); // Auto-converts <i> tags to inline SVGs

// Import JS
//import menuOpen from "./menuOpen";

// Call the menu and infinite scroll functions
//menuOpen();
infiniteScroll();
